export const FOOTER_HEIGHT = "72px";
export const DEFAULT_BACKGROUND_COLOR = "#fff";

export const containerStyle = {
    default: {
        mt: 2.5,
        mb: 2.5,
        ml: 7.5,
        mr: 7.5,
    },
    flow5: {
        px: {
            xs: 2,
            md: 3,
            lg: 6,
        },
        py: 3,
    },
};
